import {
  NetworkStatus,
  type SuspenseQueryHookOptions,
  useApolloClient,
} from '@apollo/client';
import type {
  MeQuery,
  MeQueryVariables,
  MeUserFragment,
} from 'api/core/generated';
import { MeDocument, useMeSuspenseQuery } from 'api/core/generated';
import { AppApiVersions } from 'app-constants';

export const useGetUserSuspense = (
  options?: SuspenseQueryHookOptions<MeQuery, MeQueryVariables>,
) => {
  const client = useApolloClient();

  const { data, error, networkStatus, refetch } = useMeSuspenseQuery({
    context: { apiVersion: AppApiVersions.core },
    fetchPolicy: 'cache-first',
    ...options,
  });

  const quietUserRefetch = async () => {
    const result = await client.query<MeQuery>({
      query: MeDocument,
      context: { apiVersion: AppApiVersions.core },
      fetchPolicy: 'network-only',
    });

    return result.data.me;
  };

  const getUser = () => refetch();

  return {
    user: data?.me as MeUserFragment,
    userLoading: networkStatus === NetworkStatus.loading,
    userError: error,
    userWasFetched: networkStatus === NetworkStatus.ready,
    quietUserRefetch,
    getUser,
  };
};
